import { Box, Grid, SxProps, Theme, Typography } from '@mui/material'
import React, { FC } from 'react'

const appStyles = {
    root: {
        boxShadow: (theme: Theme) => `0px 0px 0px 1px ${theme.palette.divider}`,
        p: 2,
        borderRadius: '0.4em',
        backgroundColor: (theme: Theme) => theme.palette.common.white,
    },
    title: {
        fontSize: '1rem',
        color: (theme: Theme) => theme.palette.text.secondary
    },
    bg: {
        backgroundColor: (theme: Theme) => theme.palette.grey[50],
        p: 2
    }
};

export interface GroupSummariesField {
    title: string;
    value: string | number;
}

interface GroupSummariesProps {
    /** an array of title/value pairs to summarize a report */
    groupSummaryFields: GroupSummariesField[];
    /** (optional) styles to override the default */
    styles?: SxProps
}



const GroupSummaries: FC<GroupSummariesProps> = ({
    groupSummaryFields,
    styles
}) => {


    return (
     <Box sx={{
            ...appStyles.root,
            ...styles
        }}>
            <Grid
                container
                spacing={4}
            >
                {
                    groupSummaryFields.map((field) => (
                        <Grid key={field.title} item xs={12} sm={6} md={4}>
                            <Box sx={appStyles.bg}>
                                <Typography sx={appStyles.title} variant="h6">{field.title}</Typography>
                                <Typography variant="body2">{field.value}</Typography>
                            </Box>
                        </Grid>
                    ))
                }
            </Grid>
        </Box>
    )
}

export default GroupSummaries
